import { render, staticRenderFns } from "./EventAdminView.vue?vue&type=template&id=2089b5de&"
import script from "./EventAdminView.vue?vue&type=script&lang=js&"
export * from "./EventAdminView.vue?vue&type=script&lang=js&"
import style0 from "./EventAdminView.vue?vue&type=style&index=0&id=2089b5de&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports